export default "__VITE_ASSET__Xu2_9jsS__"